(function ($) {
    "use strict";
  
    jQuery(document).ready(function(){
  
	/*----- main slider -----*/
	$('#mainSlider').nivoSlider({
        directionNav: true,
		animSpeed: 500,
		slices: 18,
		pauseTime: 5000,
		pauseOnHover: true,
		controlNav: false,
        prevText: '<i class="fa fa-angle-left nivo-prev-icon"></i>',
		nextText: '<i class="fa fa-angle-right nivo-next-icon"></i>'
	});
      
     });   
	
})(jQuery);

